<template>
  <ListLayout
    :title="customerLocationUpdateModule.customerLocationUpdate"
    ref="listTable"
    :tableData="customerLocationUpdateList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :context="context"
    @getList="getCustomerLocationUpdateList"
  >
    <template #extraSpace>
      <div class="d-flex justify-center">
        <v-chip-group
          v-model="selectedFilter"
          @change="getCustomerLocationUpdateList"
        >
          <v-chip
            filter
            outlined
            :value="{ is_approved: true, is_rejected: false }"
          >
            Approved
          </v-chip>
          <v-chip
            filter
            outlined
            :value="{ is_approved: false, is_rejected: true }"
          >
            Rejected
          </v-chip>
          <v-chip
            filter
            outlined
            :value="{ is_approved: false, is_rejected: false }"
          >
            Pending
          </v-chip>
        </v-chip-group>
      </div>
    </template>
    <template #dialogs>
      <CustomerLocationUpdateDetails
        v-model="showDetailsDialog"
        :customerLocationId="selectedCustomerLocationID"
        @approve="approveLocationUpdate"
        @reject="disApproveLocationUpdate"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import CustomerLocationUpdateButton from "@/components/Button/CustomerLocationUpdateButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { customerLocationUpdateModule } from "@/utils/moduleMapping";
import CustomerLocationUpdateDetails from "@/components/ModuleBasedComponents/CustomerLocationUpdate/CustomerLocationUpdateDetails.vue";

export default {
  components: {
    CustomerLocationUpdateButton,
    ListLayout,
    CustomerLocationUpdateDetails,
  },
  data() {
    return {
      customerLocationUpdateModule,
      permissions: null,

      selectedCustomerLocationID: null,
      showDetailsDialog: false,

      sorting: {},
      totalItems: 0,
      filters: {},
      customerLocationUpdateList: [],
      headerSelected: [
        {
          headerName: "Driver Name",
          field: "driver_name",
          sortable: true,
          pinned: "left",
          minWidth: 150,
        },
        {
          headerName: "Location ID",
          field: "location_id",
          sortable: true,
          pinned: "left",
          minWidth: 150,
        },
        {
          headerName: "Trip",
          field: "trip_reference_number",
          sortable: true,
        },
        {
          headerName: "Previous Address",
          field: "previous_address",
          sortable: true,
          tooltipField: "address",
        },
        {
          headerName: "Updated Address",
          field: "updated_address",
          sortable: true,
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
          cellRenderer: (params) => {
            return !params.data.is_approved && !params.data.is_rejected
              ? "Pending"
              : params.data.is_approved && !params.data.is_rejected
              ? "Approved"
              : "Rejected";
          },
        },
        {
          headerName: "Created On",
          field: "created",
          sortable: true,
        },
      ],
      selectedFilter: null,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 110,
          sortable: false,
          width: 150,
          cellRenderer: "CustomerLocationUpdateButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
  },
  methods: {
    getCustomerLocationUpdateList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        ...this.filters,
      };

      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      if (this.selectedFilter) {
        params = {
          ...this.selectedFilter,
        };
      }
      this.$api.customerLocationUpdate
        .getCustomerLocationUpdateList(params)
        .then((res) => {
          this.customerLocationUpdateList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    approveLocationUpdate(id) {
      this.$root
        .$confirm(
          "Confirmation",
          "Are you sure you want to approve location update?",
          { color: "secondary" }
        )
        .then((response) => {
          if (response) {
            this.$api.customerLocationUpdate
              .approveChanges(id)
              .then(() => {
                bus.$emit("showToastMessage", {
                  message: "Customer location update approved!",
                  color: "success",
                });
                this.showDetailsDialog = false;
                this.$refs.listTable.refreshList();
              })
              .catch((err) => {
                console.log(err);
                bus.$emit("showToastMessage", {
                  message: "Something went wrong!",
                  color: "error",
                });
              });
          }
        });
    },
    disApproveLocationUpdate(id) {
      this.$root
        .$confirm(
          "Confirmation",
          "Are you sure you want to reject location update?",
          { color: "error" }
        )
        .then((response) => {
          if (response) {
            this.$api.customerLocationUpdate
              .disApproveChanges(id)
              .then(() => {
                bus.$emit("showToastMessage", {
                  message: "Customer location update disapproved!",
                  color: "success",
                });
                this.showDetailsDialog = false;
                this.$refs.listTable.refreshList();
              })
              .catch((err) => {
                console.log(err);
                bus.$emit("showToastMessage", {
                  message: "Something went wrong!",
                  color: "error",
                });
              });
          }
        });
    },
    viewCustomerLocationUpdateDetails(id) {
      this.selectedCustomerLocationID = id;
      this.showDetailsDialog = true;
    },
  },
  created() {
    if (this.$route.query) {
      this.selectedFilter = this.$route.query;
    }
    this.permissions = this.$permissions.getPermission("customer");
  },
};
</script>
